import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import de from './translations/de.json';
import en from './translations/en.json';
import es from './translations/es.json';
import fr from './translations/fr.json';
import id from './translations/id.json';
import ja from './translations/ja.json';
import ko from './translations/ko.json';
import zh from './translations/zh.json';


i18n
  .use(initReactI18next)
  .init({
    lng: "en",
    // we init with resources
    resources: {
      de: {
        translations: de
      },
      en: {
        translations: en
      },
      es: {
        translations: es
      },
      fr: {
        translations: fr
      },
      id: {
        translations: id
      },
      ja: {
        translations: ja
      },
      ko: {
        translations: ko
      },
      zh: {
        translations: zh
      }
    },
    fallbackLng: "en",
    debug: false,

    // have a common namespace used around the full app
    ns: ["translations"],
    defaultNS: "translations",

    keySeparator: false, // we use content as keys

    interpolation: {
      escapeValue: false, // not needed for react!!
      formatSeparator: ","
    },

    react: {
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i']
    }
});

export default i18n;